"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENABLE_LANGUAGE_SPECIFIC_REDIRECTS = exports.ADD_DOMAIN_LANG_TO_SLUG = exports.CONTENT_LANGUAGE = exports.LANGUAGE_SETTINGS = void 0;
var LANGUAGE_SETTINGS = 'LanguageSettings';
exports.LANGUAGE_SETTINGS = LANGUAGE_SETTINGS;
var CONTENT_LANGUAGE = 'contentLanguage';
exports.CONTENT_LANGUAGE = CONTENT_LANGUAGE;
var ADD_DOMAIN_LANG_TO_SLUG = 'addDomainLangToSlug';
exports.ADD_DOMAIN_LANG_TO_SLUG = ADD_DOMAIN_LANG_TO_SLUG;
var ENABLE_LANGUAGE_SPECIFIC_REDIRECTS = 'enableLanguageSpecificRedirects';
exports.ENABLE_LANGUAGE_SPECIFIC_REDIRECTS = ENABLE_LANGUAGE_SPECIFIC_REDIRECTS;